// extracted by mini-css-extract-plugin
module.exports = {"excerpt":"excerpt-module__excerpt___1y1u5","content":"excerpt-module__content___1_Xs1"};